export default __webpack_public_path__ + "static/media/1217.c94db30b.png";